import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const StructuredData: React.FC = () => {
  const { language } = useLanguage();
  
  useEffect(() => {
    // Clear previous scripts
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(script => {
      if (script.textContent?.includes('ProfessionalService') || script.textContent?.includes('WebSite')) {
        script.remove();
      }
    });
    
    // LocalBusiness + ProfessionalService structured data
    const businessScript = document.createElement('script');
    businessScript.type = 'application/ld+json';
    businessScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': ['ProfessionalService', 'LocalBusiness'],
      'name': 'GrenzExpert',
      'description': language === 'de'
        ? 'Verwaltungs- und Steuerberatung für Privatpersonen im deutsch-französischen Grenzgebiet'
        : 'Accompagnement administratif et fiscal pour les particuliers dans la zone frontalière franco-allemande',
      'url': `https://www.grenzexpert.com/${language}/home`,
      'logo': {
        '@type': 'ImageObject',
        'url': 'https://www.grenzexpert.com/icon-512x512.png',
        'contentUrl': 'https://www.grenzexpert.com/icon-512x512.png'
      },
      'image': 'https://www.grenzexpert.com/og-image.png',
      'areaServed': [
        {
          '@type': 'State',
          'name': 'Grand-Est',
          'addressCountry': 'FR',
        },
        {
          '@type': 'State',
          'name': 'Saarland',
          'addressCountry': 'DE',
        },
      ],
      'serviceType': language === 'de'
        ? [
          'Steuerberatung für Grenzgänger',
          'Steuererklärung',
          'Verwaltungsbegleitung',
        ]
        : [
          'Conseil fiscal frontalier',
          'Déclaration d\'impôts',
          'Accompagnement administratif',
        ],
      'sameAs': [
        'https://www.facebook.com/profile.php?id=61586900165934',
        'https://www.instagram.com/grenzexpert'
      ],
    });
    
    document.head.appendChild(businessScript);
    
    return () => {
      businessScript.remove();
    };
  }, [language]);

  return null;
};

export default StructuredData;
